export function TrashIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-label="Trash Icon"
      role="img"
    >
      <path
        d="M2.5 4H13.5M6 4V2.5C6 2.22386 6.22386 2 6.5 2H9.5C9.77614 2 10 2.22386 10 2.5V4M3.75 4L4.29 13.0287C4.32 13.5695 4.7651 14 5.30621 14H10.6938C11.2349 14 11.68 13.5695 11.71 13.0287L12.25 4M6.5 7V11.5M9.5 7V11.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
